// extracted by mini-css-extract-plugin
export default {"item":"View_item__VTZJO","button":"View_button__t4MnA","buttonIcon":"View_buttonIcon__TgB4w","buttonLast":"View_buttonLast__Va1Y2"};